import { LoaderComponent } from './loader.component';
 import { NgModule } from '@angular/core';
 import { CommonModule } from '@angular/common';

 @NgModule({
   declarations: [
     LoaderComponent
   ],
   imports: [
     CommonModule
   ],
   exports: [
     LoaderComponent
   ],
   providers: [

   ]
 })
 export class LoaderModule { }
